export default "__VITE_ASSET__BQlVoe1l__"